import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import { AboutPage } from "./pages/AboutPage";
import { NIP19Page } from "./pages/NIP19Page";
import { ArticlePage } from "./pages/ArticlePage";
import { ArticleEditPage } from "./pages/ArticleEditPage";
import { ArticleHistoryPage } from "./pages/ArticleHistoryPage";
import { DraftsPage } from "./pages/DraftsPage";
import { SearchPage } from "./pages/SearchPage";
import { FeedPage } from "./pages/FeedPage";
import { AllArticlesPage } from "./pages/AllArticlesPage";
import { PublishersPage } from "./pages/PublishersPage";
import { TopStarredPage } from "./pages/TopStarredPage";
import { MediaPage } from "./pages/MediaPage";
import { PublicationPage } from "./pages/PublicationPage";
import { PublicationEditPage } from "./pages/PublicationEditPage";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/search/:query" element={<SearchPage />} />
        <Route path="/feed" element={<FeedPage />} />
        <Route path="/articles" element={<AllArticlesPage />} />
        <Route path="/publishers" element={<PublishersPage />} />
        <Route path="/stars" element={<TopStarredPage />} />
        <Route path="/drafts" element={<DraftsPage />} />
        <Route path="/media" element={<MediaPage />} />
        {/* New article (no author yet — pick a title first) */}
        <Route path="/w/:slug/edit" element={<ArticleEditPage />} />
        <Route path="/w/:slug/history" element={<ArticleHistoryPage />} />
        {/* A specific author's version of an article */}
        <Route path="/w/:slug/:npub" element={<ArticlePage />} />
        {/* The most recent/top-ranked version of an article */}
        <Route path="/w/:slug" element={<ArticlePage />} />
        {/* NKBIP-01 curated publications (kind 30040/30041) */}
        <Route path="/p/new" element={<PublicationEditPage />} />
        <Route path="/p/:d/edit" element={<PublicationEditPage />} />
        <Route path="/p/:d/:npub/:sectionD" element={<PublicationPage />} />
        <Route path="/p/:d/:npub" element={<PublicationPage />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;